<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script type="text/javascript">
    export default {
        name: 'App',
        created() {
            this.$router.replace({
                path: '/'
            });
            // 进入系统：判断是否登录
            // if (localStorage.getItem('accountData')) { // 已登录
            //     this.$router.replace({path: '/'});
            // } else { // 未登录
            //     this.$router.push('/login');
            // };
            localStorage.setItem('language', 'zh-cn');
        },
        mounted() {
            // console.log('<---------- 当前账户 ---------->');
            // console.log(this.$store.state.accountData);
        }
    }
</script>



// WEBPACK FOOTER //
// src/app.vue